import { Component, Input } from '@angular/core';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from 'src/app/services/inventory.service';
import { TemplateService } from 'src/app/services/template.service';
import { InventoryItemComponentInterface } from '@contracts/interfaces/inventory-item-component.interface';

@Component({
  selector: 'app-item-title',
  templateUrl: './item-title.component.html',
  styleUrls: ['./item-title.component.scss']
})
export class ItemTitleComponent implements InventoryItemComponentInterface {

  @Input()
  public item: InventoryItem;

  @Input()
  public data: any;

  constructor(
    private inventoryService: InventoryService,
    private templateService: TemplateService
    ) { }

  ngOnInit() {
    this.checkTitleLength(this.item.title);
    // this.inventoryService.itemUpdatedEvent.subscribe(item => {
    //   this.generateDynamic();
    // })
  }

  save() {
    this.item.lastModified = new Date();
    this.inventoryService.updateOne(this.item).subscribe();
  }

  check() {
    console.log(this.item);
  }

  generateDynamic() {

    if (this.data.title == "" || this.data.title == undefined) {
      return;
    }

    this.templateService.render(this.data.title, this.item).subscribe((r: any)=> {
      this.item.title = r.render;
      this.checkTitleLength(this.item.title);
      this.save();
    });
  }

  addLog(value: string) {
    if (this.item.log == undefined) {
        this.item.log = [];
    }

    this.item.log.push({
        text: value,
        date: new Date()
    });
    
    this.save();
  }

  resetLog() {
      this.item.log = [];
      this.addLog("Log was cleared");
  }

  public titleClassForSize: string = "large";
  checkTitleLength(title: string) {
    if (title.length < 50) { 
      this.titleClassForSize = "larger";    
    } else if (title.length < 63) {
      this.titleClassForSize = "large";
    } else if (title.length < 75) {
      this.titleClassForSize = "medium";
    } else if (title.length < 80) {
      this.titleClassForSize = "small";
    }
  }

}
